import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable, shareReplay } from "rxjs"
import { environment } from "src/environments/environment"
import { CreateLocation, Location, PagedLocation, ModifyObject } from "../models"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetLocationPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Injectable({
    providedIn: "root",
})
export class LocationsService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.locations

    private _allCached$: Observable<Location[]> | undefined

    Get(): Observable<Location[]> {
        return this._http.get<Location[]>(this._apiUrl)
    }

    GetAllCached(): Observable<Location[]> {
        if (!this._allCached$) {
            this._allCached$ = this.Get().pipe(shareReplay({ bufferSize: 1, refCount: false }))
        }
        return this._allCached$
    }

    GetByMasterId(masterId: string): Observable<Location> {
        return this._http.get<Location>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetLocationPagedParams): Observable<PagedLocation> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedLocation>(request.url, { params: request.params })
    }
    PagedRequest(params: GetLocationPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createLocation: CreateLocation): Observable<Location> {
        return this._http.post<Location>(this._apiUrl, createLocation)
    }

    Modify(masterId: string, data: ModifyObject): Observable<any> {
        return this._http.patch(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
